import { apiUtils, getLoanBaseUrl } from '../api-utils';


export function getDerogatories(clientId: string, loanId: string): Promise<Derogatory[]> {
    return apiUtils.get(`${getLoanBaseUrl(clientId, loanId)}/derogatory`);
}

export function createDerogatory(
    clientId: string, loanId: string, derogatory: Derogatory
): Promise<Derogatory> {
    return apiUtils.post(`${getLoanBaseUrl(clientId, loanId)}/derogatory`, derogatory);
}

export function updateDerogatory(
    clientId: string, loanId: string, derogatoryId: string, derogatory: Derogatory
): Promise<Derogatory> {
    return apiUtils.put(`${getLoanBaseUrl(clientId, loanId)}/derogatory/${derogatoryId}`, derogatory);
}

export function deleteDerogatory(clientId: string, loanId: string, derogatoryId: string): Promise<void> {
    return apiUtils.delete(`${getLoanBaseUrl(clientId, loanId)}/derogatory/${derogatoryId}`);
}


export interface Derogatory {
    id: string;
    underwritingInstanceId?: string;
    entityId?: string;
    type: DerogatoryType;
    borrower: UnderwritingBorrowerType;
    bankruptcyType?: BankruptcyType;
    disposition?: DispositionType;
    extenuating?: string;
    plaintiff?: string;
    amount?: number;
    company?: string;
    accountNumber?: string;
    payingOff?: boolean;
    date?: string; // ISO date string
}

export enum DerogatoryType {
    BANKRUPTCY = 'BANKRUPTCY',
    FORECLOSURE = 'FORECLOSURE',
    SHORT_SALE = 'SHORT_SALE',
    OUTSTANDING_JUDGEMENT = 'OUTSTANDING_JUDGEMENT',
    LIEN = 'LIEN',
    OPEN_COLLECTIONS = 'OPEN_COLLECTIONS',
    CHARGE_OFFS = 'CHARGE_OFFS'
}

export const derogatoryTypeDisplay: Record<DerogatoryType, string> = {
    [DerogatoryType.BANKRUPTCY]: 'Bankruptcy',
    [DerogatoryType.FORECLOSURE]: 'Foreclosure',
    [DerogatoryType.SHORT_SALE]: 'Short Sale',
    [DerogatoryType.OUTSTANDING_JUDGEMENT]: 'Outstanding Judgement',
    [DerogatoryType.LIEN]: 'Lien',
    [DerogatoryType.OPEN_COLLECTIONS]: 'Open Collections',
    [DerogatoryType.CHARGE_OFFS]: 'Charge Offs'
};

export enum UnderwritingBorrowerType {
    BORROWER = 'BORROWER',
    COBORROWER = 'COBORROWER',
    BOTH = 'BOTH'
}

export const borrowerTypeDisplay: Record<UnderwritingBorrowerType, string> = {
    [UnderwritingBorrowerType.BORROWER]: 'Borrower',
    [UnderwritingBorrowerType.COBORROWER]: 'Co-Borrower',
    [UnderwritingBorrowerType.BOTH]: 'Both'
};

export enum BankruptcyType {
    CHAPTER_SEVEN = 'CHAPTER_SEVEN',
    CHAPTER_ELEVEN = 'CHAPTER_ELEVEN',
    CHAPTER_TWELVE = 'CHAPTER_TWELVE',
    CHAPTER_THIRTEEN = 'CHAPTER_THIRTEEN'
}

export const bankruptcyTypeDisplay: Record<BankruptcyType, string> = {
    [BankruptcyType.CHAPTER_SEVEN]: 'Chapter 7',
    [BankruptcyType.CHAPTER_ELEVEN]: 'Chapter 11',
    [BankruptcyType.CHAPTER_TWELVE]: 'Chapter 12',
    [BankruptcyType.CHAPTER_THIRTEEN]: 'Chapter 13'
};

export enum DispositionType {
    DISCHARGED = 'DISCHARGED',
    DISMISSED = 'DISMISSED',
    OPEN = 'OPEN'
}

export const dispositionTypeDisplay: Record<DispositionType, string> = {
    [DispositionType.DISCHARGED]: 'Discharged',
    [DispositionType.DISMISSED]: 'Dismissed',
    [DispositionType.OPEN]: 'Open'
};
